import * as React from 'react';

/**
 * Context for rendering Dropdown (Menu.Portal) content inside a Dialog.
 * When a Dialog provides this context, DropdownContent will portal into the dialog popup
 * instead of document.body, so the dropdown appears above the modal without raising global z-index.
 * Base UI Menu.Portal supports a `container` prop for this.
 */
export const DropdownPortalContainerContext = React.createContext<React.RefObject<HTMLElement | null> | null>(null);

export function useDropdownPortalContainer(): HTMLElement | null {
	const ref = React.useContext(DropdownPortalContainerContext);
	return ref?.current ?? null;
}
